module.exports = __webpack_public_path__ + "img/pencil-pri.51f3564e.svg";